// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ab-board {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
  font-family: Lato, sans-serif;
  color: #0f172a;
}

.ab-col {
  min-width: 0;
}

.ab-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.ab-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 15px 18px;
  border-bottom: 1px solid #eaeff7;
  flex-wrap: wrap;
}

.ab-card-head h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
}

.ab-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 10px 14px;
  background: #f7f9fd;
  border-bottom: 1px solid #eaeff7;
}

.ab-chip {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 13px;
  border-radius: 99px;
  border: 1px solid #dee4f0;
  background: #fff;
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: #5b6b87;
  cursor: pointer;
  transition: all 0.14s;
  width: auto !important;
}

.ab-chip:hover {
  border-color: #8b99b4;
  color: #0f172a;
}

.ab-chip.on {
  background: #e1f4f0;
  border-color: transparent;
  color: #076b5c;
  font-weight: 500;
}

.ab-count-note {
  margin-left: auto;
  font-size: 14px;
  color: #5b6b87;
}

.ab-task-list {
  padding: 14px 16px;
  display: grid;
  gap: 12px;
  max-height: min(62vh, 640px);
  overflow-y: auto;
}

.ab-task-list::-webkit-scrollbar {
  width: 6px;
}

.ab-task-list::-webkit-scrollbar-thumb {
  background: #c5d0dc;
  border-radius: 99px;
}

.ab-task-card {
  border: 1px solid #dee4f0;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ab-task-card:hover {
  border-color: #00146d;
  box-shadow: 0 8px 24px -16px rgba(0, 20, 109, 0.35);
}

.ab-tc-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ab-tc-top > div {
  min-width: 0;
  flex: 1 1;
}

.ab-tc-top h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
}

.ab-tc-top p {
  margin: 4px 0 0;
  font-size: 14.5px;
  color: #5b6b87;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ab-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 99px;
  flex: none;
  white-space: nowrap;
}

.ab-dot {
  width: 5px;
  height: 5px;
  border-radius: 99px;
  background: currentColor;
}

.ab-pill.p-crit {
  background: #fae6e3;
  color: #96271b;
}

.ab-pill.p-high {
  background: #faefda;
  color: #84540a;
}

.ab-pill.p-med {
  background: #e6eff8;
  color: #22548a;
}

.ab-pill.p-low,
.ab-pill.p-todo {
  background: #e2f7f2;
  color: #0e8271;
}

.ab-pill.p-prog {
  background: #e6eaf6;
  color: #22548a;
}

.ab-pill.p-mute {
  background: #eaeff7;
  color: #5b6b87;
}

.ab-tc-chips {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.ab-tc-due {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 13px;
  color: #5b6b87;
  margin-left: auto;
}

.ab-tc-due svg {
  width: 13px;
  height: 13px;
  opacity: 0.6;
}

.ab-tc-foot {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #eaeff7;
  flex-wrap: wrap;
}

.ab-av {
  width: 32px;
  height: 32px;
  border-radius: 99px;
  flex: none;
  display: grid;
  place-items: center;
  background: rgba(0, 20, 109, 0.08);
  color: #00146d;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid rgba(0, 20, 109, 0.12);
}

.ab-tc-meta {
  font-size: 13px;
  color: #5b6b87;
  line-height: 1.4;
  min-width: 0;
}

.ab-tc-meta b {
  display: block;
  color: #0f172a;
  font-weight: 500;
  font-size: 13.5px;
}

.ab-tc-actions {
  margin-left: auto;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.ab-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
  width: auto !important;
}

.ab-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.ab-btn-primary {
  border: none;
  background: #00146d;
  color: #fff;
}

.ab-btn-primary:hover {
  background: #1b2f8f;
}

.ab-btn-ghost {
  border: 1px solid #dee4f0;
  background: #fff;
  color: #0f172a;
}

.ab-btn-ghost:hover {
  background: #f7f9fd;
  border-color: #8b99b4;
}

.ab-loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.ab-spinner {
  width: 28px;
  height: 28px;
  border: 2.5px solid #dee4f0;
  border-top-color: #00146d;
  border-radius: 99px;
  animation: ab-spin 0.7s linear infinite;
}

@keyframes ab-spin {
  to {
    transform: rotate(360deg);
  }
}

.ab-error {
  color: #96271b;
  font-weight: 600;
  padding: 16px;
}

@media (max-width: 980px) {
  .ab-board {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .ab-tc-actions {
    margin-left: 0;
    width: 100%;
  }

  .ab-tc-due {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/containers/ActionsBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".ab-board {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  align-items: start;\n  font-family: Lato, sans-serif;\n  color: #0f172a;\n}\n\n.ab-col {\n  min-width: 0;\n}\n\n.ab-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n}\n\n.ab-card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 15px 18px;\n  border-bottom: 1px solid #eaeff7;\n  flex-wrap: wrap;\n}\n\n.ab-card-head h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.ab-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 10px 14px;\n  background: #f7f9fd;\n  border-bottom: 1px solid #eaeff7;\n}\n\n.ab-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 32px;\n  padding: 0 13px;\n  border-radius: 99px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  color: #5b6b87;\n  cursor: pointer;\n  transition: all 0.14s;\n  width: auto !important;\n}\n\n.ab-chip:hover {\n  border-color: #8b99b4;\n  color: #0f172a;\n}\n\n.ab-chip.on {\n  background: #e1f4f0;\n  border-color: transparent;\n  color: #076b5c;\n  font-weight: 500;\n}\n\n.ab-count-note {\n  margin-left: auto;\n  font-size: 14px;\n  color: #5b6b87;\n}\n\n.ab-task-list {\n  padding: 14px 16px;\n  display: grid;\n  gap: 12px;\n  max-height: min(62vh, 640px);\n  overflow-y: auto;\n}\n\n.ab-task-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ab-task-list::-webkit-scrollbar-thumb {\n  background: #c5d0dc;\n  border-radius: 99px;\n}\n\n.ab-task-card {\n  border: 1px solid #dee4f0;\n  border-radius: 10px;\n  padding: 14px 16px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ab-task-card:hover {\n  border-color: #00146d;\n  box-shadow: 0 8px 24px -16px rgba(0, 20, 109, 0.35);\n}\n\n.ab-tc-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.ab-tc-top > div {\n  min-width: 0;\n  flex: 1;\n}\n\n.ab-tc-top h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n  line-height: 1.35;\n}\n\n.ab-tc-top p {\n  margin: 4px 0 0;\n  font-size: 14.5px;\n  color: #5b6b87;\n  line-height: 1.45;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.ab-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 99px;\n  flex: none;\n  white-space: nowrap;\n}\n\n.ab-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 99px;\n  background: currentColor;\n}\n\n.ab-pill.p-crit {\n  background: #fae6e3;\n  color: #96271b;\n}\n\n.ab-pill.p-high {\n  background: #faefda;\n  color: #84540a;\n}\n\n.ab-pill.p-med {\n  background: #e6eff8;\n  color: #22548a;\n}\n\n.ab-pill.p-low,\n.ab-pill.p-todo {\n  background: #e2f7f2;\n  color: #0e8271;\n}\n\n.ab-pill.p-prog {\n  background: #e6eaf6;\n  color: #22548a;\n}\n\n.ab-pill.p-mute {\n  background: #eaeff7;\n  color: #5b6b87;\n}\n\n.ab-tc-chips {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n\n.ab-tc-due {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 13px;\n  color: #5b6b87;\n  margin-left: auto;\n}\n\n.ab-tc-due svg {\n  width: 13px;\n  height: 13px;\n  opacity: 0.6;\n}\n\n.ab-tc-foot {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid #eaeff7;\n  flex-wrap: wrap;\n}\n\n.ab-av {\n  width: 32px;\n  height: 32px;\n  border-radius: 99px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  background: rgba(0, 20, 109, 0.08);\n  color: #00146d;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid rgba(0, 20, 109, 0.12);\n}\n\n.ab-tc-meta {\n  font-size: 13px;\n  color: #5b6b87;\n  line-height: 1.4;\n  min-width: 0;\n}\n\n.ab-tc-meta b {\n  display: block;\n  color: #0f172a;\n  font-weight: 500;\n  font-size: 13.5px;\n}\n\n.ab-tc-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.ab-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n  width: auto !important;\n}\n\n.ab-btn:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.ab-btn-primary {\n  border: none;\n  background: #00146d;\n  color: #fff;\n}\n\n.ab-btn-primary:hover {\n  background: #1b2f8f;\n}\n\n.ab-btn-ghost {\n  border: 1px solid #dee4f0;\n  background: #fff;\n  color: #0f172a;\n}\n\n.ab-btn-ghost:hover {\n  background: #f7f9fd;\n  border-color: #8b99b4;\n}\n\n.ab-loading {\n  display: flex;\n  justify-content: center;\n  padding: 48px 0;\n}\n\n.ab-spinner {\n  width: 28px;\n  height: 28px;\n  border: 2.5px solid #dee4f0;\n  border-top-color: #00146d;\n  border-radius: 99px;\n  animation: ab-spin 0.7s linear infinite;\n}\n\n@keyframes ab-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ab-error {\n  color: #96271b;\n  font-weight: 600;\n  padding: 16px;\n}\n\n@media (max-width: 980px) {\n  .ab-board {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 520px) {\n  .ab-tc-actions {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .ab-tc-due {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
